// Определяем основные переменные темы без зависимости от MUI
export const theme = {
    palette: {
        primary: {
            main: '#5ebeb3',
            light: '#8eefe4',
            dark: '#328f86',
        },
        secondary: {
            main: '#f50057',
            light: '#ff4081',
            dark: '#c51162',
        },
        background: {
            default: '#f5f5f5',
            paper: '#ffffff',
        },
    },
    typography: {
        fontFamily: '"Roboto", "Arial", sans-serif',
        fontSize: {
            h1: '2rem',
            h2: '1.75rem',
            h3: '1.5rem',
            body1: '1rem',
            body2: '0.875rem',
        },
        fontWeight: {
            regular: 400,
            medium: 500,
            bold: 700,
        },
    },
    spacing: (factor: number) => `${0.5 * factor}rem`,
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1920,
        },
    },
};

// Функция для экспорта CSS переменных темы
export const initThemeVariables = () => {
    const root = document.documentElement;

    // Палитра
    root.style.setProperty('--primary-main', theme.palette.primary.main);
    root.style.setProperty('--primary-light', theme.palette.primary.light);
    root.style.setProperty('--primary-dark', theme.palette.primary.dark);
    root.style.setProperty('--secondary-main', theme.palette.secondary.main);
    root.style.setProperty('--secondary-light', theme.palette.secondary.light);
    root.style.setProperty('--secondary-dark', theme.palette.secondary.dark);
    root.style.setProperty('--background-default', theme.palette.background.default);
    root.style.setProperty('--background-paper', theme.palette.background.paper);

    // Типография
    root.style.setProperty('--font-family', theme.typography.fontFamily);
    root.style.setProperty('--font-size-h1', theme.typography.fontSize.h1);
    root.style.setProperty('--font-size-h2', theme.typography.fontSize.h2);
    root.style.setProperty('--font-size-h3', theme.typography.fontSize.h3);
    root.style.setProperty('--font-size-body1', theme.typography.fontSize.body1);
    root.style.setProperty('--font-size-body2', theme.typography.fontSize.body2);
};

// Экспортируем тип темы для типизации в компонентах
export type Theme = typeof theme;